module.exports = __webpack_public_path__ + "static/img/bg2.b2b0021d.jpeg";